import { Attempt } from '@/common/types/session';
import { formatTimeTaken } from '@/common/utils/datetime';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import {
  CorrectChoice,
  IncorrectChoice,
  OtherOption,
  OtherOptionsCell,
} from './CellStyles';
import GenericAttemptTable, {
  getControlIcon,
  getHasControl,
} from './GenericAttemptTable';

interface MysticMatchAttemptTableProps {
  attempts: Attempt[];
}
export default function MysticMatchAttemptTable({
  attempts,
}: MysticMatchAttemptTableProps) {
  const hasControl = getHasControl(attempts);
  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Attempt</TableHead>
          <TableHead>Correct Answer</TableHead>
          <TableHead>Student Choice</TableHead>
          <TableHead>Other Cards Presented</TableHead>
          <TableHead>Time Taken</TableHead>
          {hasControl && <TableHead>Control</TableHead>}
        </TableRow>
      )}
      renderData={() =>
        attempts.map((attempt, index) => (
          <TableRow key={index} className="hover:bg-white">
            <TableCell>{index + 1}</TableCell>
            <TableCell>{attempt.correctAnswer}</TableCell>
            <TableCell>
              {attempt.studentAnswer === attempt.correctAnswer ? (
                <CorrectChoice>{attempt.studentAnswer}</CorrectChoice>
              ) : (
                <IncorrectChoice>{attempt.studentAnswer}</IncorrectChoice>
              )}
            </TableCell>
            <OtherOptionsCell>
              {(attempt.incorrectAnswers || []).map((choice, choiceIndex) => (
                <OtherOption key={choiceIndex}>{choice}</OtherOption>
              ))}
            </OtherOptionsCell>
            <TableCell>
              {formatTimeTaken(attempt.startedAt, attempt.endedAt)}
            </TableCell>
            {hasControl && (
              <TableCell className="pl-6">
                {getControlIcon(attempt.control!)}
              </TableCell>
            )}
          </TableRow>
        ))
      }
      isEmpty={attempts.length === 0}
    />
  );
}
